"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_OldOrcishWays_OnDamagedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Ability_OldOrcishWays_OnDamagedEventHandlerScript = class Ability_OldOrcishWays_OnDamagedEventHandlerScript {
    run(sequence, container, handler, event) {
        const { turns, effect } = (0, Random_1.randomWeightedElement)([
            {
                weight: 1,
                value: {
                    turns: 1,
                    effect: new core_1.StunEffectArgs()
                }
            },
            {
                weight: 1,
                value: {
                    turns: 3,
                    effect: new core_1.PoisonedEffectArgs("Power", 10)
                }
            },
            {
                weight: 1,
                value: {
                    turns: 1,
                    effect: new core_1.DarknessEffectArgs()
                }
            }
        ]);
        container.applyEffect(sequence, event.subject, event.args.damagedBy, effect, Duration_1.Duration.Turns(turns), false);
    }
};
Ability_OldOrcishWays_OnDamagedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Ability_OldOrcishWays_OnDamaged")
], Ability_OldOrcishWays_OnDamagedEventHandlerScript);
exports.Ability_OldOrcishWays_OnDamagedEventHandlerScript = Ability_OldOrcishWays_OnDamagedEventHandlerScript;
